<template>
    <div id="resetPasswordIndex">
        <lang-select class="set-language"></lang-select>
        <div class="reset-step-box">
            <el-steps :active="stepActiveNum" finish-status="success" align-center>
                <el-step :title="$t('Form.EmailOrPhone')" description=""></el-step>
                <el-step :title="$t('Form.Verify')" description=""></el-step>
                <el-step :title="$t('Form.Reset')" description=""></el-step>
                <el-step :title="$t('Form.Complete')" description=""></el-step>
            </el-steps>
        </div>
        <div class="reset-password-box">
            <transition mode="out-in" :enter-active-class="enterActiveClass" :leave-active-class="leaveActiveClass" v-if="!isShowResetCard">
                <sign-user-card
                    :title="$t('Form.RetrievePassword')"
                    id="sign-card-1"
                    key="sign-card-1"
                    class="animated fast"
                    v-if="index === 1"
                    @nextStepClick="nextStepClick"
                ></sign-user-card>
                <verify-email-card
                    :title="$t('Form.RetrievePassword')"
                    :email="email"
                    id="sign-card-12"
                    key="sign-card-2"
                    class="animated fast"
                    v-if="index === 2"
                    @backClick="handleBackClick"
                ></verify-email-card>
            </transition>
            <transition mode="out-in" :enter-active-class="enterActiveClass" :leave-active-class="leaveActiveClass" v-if="isShowResetCard">
                <reset-password-card
                    :title="$t('Form.ResetPassword')"
                    :backWay="backWay"
                    :resetKey="resetKey"
                    id="card-1"
                    class="animated fast"
                    v-if="index === 1"
                    key="card-1"
                    @nextStepClick="nextStepClick"
                ></reset-password-card>
                <reset-success-card
                    :title="$t('Form.ResetPassword')"
                    id="card-2"
                    class="animated fast"
                    v-if="index === 2"
                    key="card-2"
                    @backClick="handleBackClick"
                ></reset-success-card>
            </transition>
        </div>
    </div>
</template>

<script>
import SignUserCard from './components/signUserCard'
import VerifyEmailCard from './components/verifyEmailCard'
import ResetPasswordCard from './components/resetPasswordCard'
import ResetSuccessCard from './components/resetSuccessCard'

export default {
    name: 'ResetPasswordIndex',
    components: {
        SignUserCard,
        VerifyEmailCard,
        ResetPasswordCard,
        ResetSuccessCard,
    },
    data() {
        return {
            stepActiveNum: 0,
            isShowResetCard: false,
            index: 1, //显示的组件索引--初始定位1即第一张内容卡片
            enterActiveClass: 'zoomInRight',
            leaveActiveClass: 'zoomOutLeft',
            resetKey: '',
            typeVal: '', //0:主账号激活， 1:子账号激活， 2:找回密码
            mgType: 0, // 平台标示 0：物联网平台,  1：车载设备平台,  2: 应用中心   3: 项目管理系统
            email: '',
            backWay: '',  //密码找回方式
        }
    },
    methods: {
        checkRouter() {
            this.resetKey = this.$route.query.key
            this.typeVal = this.$route.query.type
            this.mgType = this.$route.query.mgType
            const language = this.$route.query.language
            if (this.mgType) {
                this.mgType = Number(this.mgType)
            } else {
                this.mgType = 0
            }
            if (this.typeVal && this.typeVal === '2') {
                if (this.resetKey !== undefined && this.resetKey !== '') {
                    this.isShowResetCard = true
                    this.stepActiveNum = 2
                } else {
                    this.isShowResetCard = false
                }
            } else {
                this.isShowResetCard = false
            }
            if (language && language !== 'undefined' && language !== 'null' && language === 'en') {
                this.$i18n.locale = 'en'
                this.$store.dispatch('app/setLanguage', 'en')
            } else {
                this.$i18n.locale = 'zh'
                this.$store.dispatch('app/setLanguage', 'zh')
            }
            /*if (language !== undefined && language === 'en'){
          this.setLanguage('en');
        }else {
          this.setLanguage('zh');
        }*/
        },
        changeIndexPlus(way) {
            this.enterActiveClass = 'zoomInRight'
            this.leaveActiveClass = 'zoomOutLeft'
            // this.index = (this.index%2)+1;

            if(way && way === 'SMS'){
                //手机短信验证码找回密码，直接进入重置密码界面
                this.index = 1
                this.stepActiveNum = 3
                this.$set(this, 'isShowResetCard', true)
            }else{
                this.index = this.index + 1
                this.stepActiveNum = this.stepActiveNum + 1
            }
        },
        changeIndexMinus() {
            this.enterActiveClass = 'zoomInLeft'
            this.leaveActiveClass = 'zoomOutRight'
            if (this.index === 1) {
                return
            }
            this.index = this.index - 1
            this.stepActiveNum = this.stepActiveNum - 1
        },
        nextStepClick(backWay, value) {
            this.backWay = backWay
            if(backWay === 'EMAIL'){
                this.email = value  //用邮箱找回，此value是 email
            }else if(backWay === 'SMS'){
                this.resetKey = value //用手机验证码找回，此value是 重置所需的key
            }
            
            this.changeIndexPlus(backWay)
        },
        handleBackClick() {
            this.changeIndexMinus()
        },
    },
    mounted(){
        this.$nextTick(() => {
            this.checkRouter()
        })
    }
}
</script>

<style lang="scss">
$color-theme: #4da1ff;

#resetPasswordIndex {
    .reset-step-box {
        width: 1000px;
        height: 50px;
        position: absolute;
        top: 15%;
        left: 50%;
        margin: -25px 0 0 -500px;

        .el-step {
            .el-step__head {
                .el-step__line {
                    top: 27.5px;
                    height: 5px;
                    background: #fff;
                }
                .el-step__icon.is-text {
                    width: 60px;
                    height: 60px;
                    font-size: 20px;
                    border-color: #fff;
                }
            }
            .el-step__head.is-success {
                color: $color-theme;
                border-color: $color-theme;
                .el-step__line {
                    background: $color-theme;
                }
                .el-step__icon.is-text {
                    background: $color-theme;
                    border-color: $color-theme;
                }
                .el-step__icon-inner.is-status.el-icon-check {
                    color: #13ec0d;
                    border-color: #13ec0d;
                    font-weight: bold;
                }
            }
            .el-step__head.is-process {
                color: $color-theme;
                border-color: $color-theme;

                .el-step__line {
                    background: linear-gradient(to right, rgba(77, 161, 255, 1), white);
                }

                .el-step__icon.is-text {
                    background: $color-theme;
                    border-color: $color-theme;
                    .el-step__icon-inner {
                        color: #fff;
                    }
                }
            }
            .el-step__main {
                .el-step__title {
                    font-size: 20px;
                }
                .is-process {
                    color: #fff;
                }
                .el-step__title.is-success {
                    color: #fff;
                }
            }
        }
    }
    .reset-password-box {
        width: 600px;
        height: 600px;
        position: absolute;
        top: 30%;
        left: 50%;
        margin: 0 0 0 -300px;
    }
}
</style>
